import React from 'react'
import { FlexRow, Text } from 'elements'

export default function InfoItems(props) {
  return (
    <FlexRow alignItems="center">
      {props.items.map((item, index) => {
        const isLast = index === props.items.length - 1

        return (
          <FlexRow
            key={item.label}
            borderRight={isLast ? null : '2px solid'}
            borderColor="background.1"
            mr={isLast ? null : 'large'}
          >
            <Text mr="xsmall" color="background.1">
              {item.label}:
            </Text>
            <Text color="background.1" mr={isLast ? null : 'large'}>
              {item.render ? item.render(item.value) : item.value}
            </Text>
          </FlexRow>
        )
      })}
    </FlexRow>
  )
}
